<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userBinFenCustomerForm"
            :model="userBinFenCustomerForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userBinFenCustomerForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userExternalCustomerName">
                    <Input v-model="userBinFenCustomerForm.userExternalCustomerName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="所属区域"
                    prop="userExternalCustomerAreaUuid">
                    <Select v-model="userBinFenCustomerForm.userExternalCustomerAreaUuid"
                        filterable>
                        <Option v-for="item in areaSource"
                            :key="item.areaUuid"
                            :value="item.areaUuid">{{ item.areaName }}</Option>
                    </Select>
                </FormItem>
                </Col>
				<Col span="6">
				<FormItem label="所属部门"
				    prop="departmentUuid">
				    <Select v-model="userBinFenCustomerForm.departmentUuid"
				        filterable>
				        <Option v-for="item in departments"
				            :key="item.departmentUuid"
				            :value="item.departmentUuid">{{ item.departmentName }}</Option>
				    </Select>
				</FormItem>
				</Col>
            </Row>

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="公司名称">
                    <Input v-model="userBinFenCustomerForm.userExternalCustomerCompanyName"></Input>
                </FormItem>
                </Col>

                <Col span="6">
                <FormItem label="省份"
                    prop="userExternalCustomerProvinceUuid">
                    <Select v-model="userBinFenCustomerForm.userExternalCustomerProvinceUuid"
                        filterable>
                        <Option v-for="item in provinceOptions"
                            :key="item.regionUuid"
                            :value="item.regionUuid">{{ item.regionName }}</Option>
                    </Select>
                </FormItem>
                </Col>

                <Col span="6">
                <FormItem label="城市"
                    prop="userExternalCustomerCityUuid">
                    <Select v-model="userBinFenCustomerForm.userExternalCustomerCityUuid"
                        filterable>
                        <Option v-for="item in cityOptions"
                            :key="item.regionUuid"
                            :value="item.regionUuid">{{ item.regionName }}</Option>
                    </Select>
                </FormItem>
                </Col>

                <Col span="6">
                <FormItem label="区域"
                    prop="userExternalCustomerDistUuid">
                    <Select v-model="userBinFenCustomerForm.userExternalCustomerDistUuid"
                        filterable>
                        <Option v-for="item in distOptions"
                            :key="item.regionUuid"
                            :value="item.regionUuid">{{ item.regionName }}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
				<Col span="6">
				<FormItem label="手机"
				    prop="userExternalCustomer">
				    <Input v-model="userBinFenCustomerForm.userExternalCustomerPhone"></Input>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="客户经理"
					prop="userExternalCustomerRelateCustomerManagerUuid">
					<Select v-model="userBinFenCustomerForm.userExternalCustomerRelateCustomerManagerUuid"
						filterable>
						<Option v-for="item in userCustomerManagerSource"
							:key="item.userCustomerManagerLoginUuid"
							:value="item.userCustomerManagerLoginUuid">{{ item.userCustomerManagerName }}</Option>
					</Select>
				</FormItem>
				</Col>
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userBinFenCustomerForm.userExternalCustomerApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { getDepartmentList } from '@/api/modules/system-management/department-management';

import {
    binFenCustomerUserSave,
    getBinFenCustomerUserDetail,
    pageInit4UserBinFenCustomerEdit
} from '@/api/modules/account-management/binFenCustomer-user-management';
import { getCustomerManagerUserList } from '@/api/modules/account-management/customerManager-user-management';

export default {
    name: 'BinFenCustomerUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userBinFenCustomerForm: {
                userExternalCustomerLoginUuid: '',
                userName: '',
                userExternalCustomerName: '',
                userExternalCustomerAreaUuid: '',
                userExternalCustomerContactNumber: '',
                userExternalCustomerPhone: '',
                userExternalCustomerWechat: '',
                userExternalCustomerEmail: '',
                userExternalCustomerApproval: APPROVAL_NO,
                userExternalCustomerCompanyName: '',
                userExternalCustomerContact: '',
                userExternalCustomerProvinceUuid: '',
                userExternalCustomerCityUuid: '',
                userExternalCustomerDistUuid: '',
                userExternalCustomerFullAddress: '',
                userExternalCustomerRelateCustomerManagerUuid:''
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userBinFenCustomerName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 2 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在2-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userExternalCustomerAreaUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userExternalCustomerProvinceUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userExternalCustomerCityUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userExternalCustomerDistUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userExternalCustomerRelateCustomerManagerUuid: [
				    { message: ' ', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            areaSource: [],
            approvalSource: [],
            regionSource: [],
            regionTop: '',
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            userCustomerManagerSource: [],
            departments: []
        };
    },
    watch: {
        'userBinFenCustomerForm.userExternalCustomerProvinceUuid': function (newValue) {
            this.userBinFenCustomerForm.userExternalCustomerCityUuid = '';
            this.cityOptions = this.regionSource.filter(r => r.regionParentUuid === newValue);
        },
        'userBinFenCustomerForm.userExternalCustomerCityUuid': function (newValue) {
            this.userBinFenCustomerForm.userExternalCustomerDistUuid = '';
            this.distOptions = this.regionSource.filter(r => r.regionParentUuid === newValue);
        }
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        getDepartmentTableRecords() {
		    getDepartmentList({}).then(res => {
		        if (res.code === 0) {
		            this.departments = res.data.records;
		        }
		    });
        },
        init() {
			
            this.$showGlobalSpin();
            this.getDepartmentTableRecords();
            getCustomerManagerUserList({}).then(res => {
			    this.$hideGlobalSpin();
			    if (res.code === 0) {
			         this.userCustomerManagerSource = res.data.records.map(item => {
			             return {
			                 userCustomerManagerLoginUuid: item.userCustomerManagerLoginUuid,
			                 userCustomerManagerName: item.userCustomerManagerName
			             };
			         });
			    }
            });
			
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });

            this.$showGlobalSpin();
            pageInit4UserBinFenCustomerEdit().then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map(item => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });
				
                    this.regionSource = res.data.region.allRegions;
                    this.regionTop = res.data.region.topParentUuid;
                    this.provinceOptions = this.regionSource.filter(r => r.regionType === 1);

                    // const query = this.$route.query;
                    if (this.accountUuid) {
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;

                        getBinFenCustomerUserDetail(this.accountUuid).then(detail => {
                            if (detail.code === 0) {
                                const info = detail.data.userBinFenCustomer;
                                this.userBinFenCustomerForm = Object.assign(this.userBinFenCustomerForm, info);

                                this.userBinFenCustomerForm.userExternalCustomerProvinceUuid = info.userExternalCustomerProvinceUuid;
                                setTimeout(() => {
                                    this.userBinFenCustomerForm.userExternalCustomerCityUuid = info.userExternalCustomerCityUuid;

                                    setTimeout(() => {
                                        this.userBinFenCustomerForm.userExternalCustomerDistUuid = info.userExternalCustomerDistUuid;
                                    }, 0);
                                }, 0);
                            }
                        });
                    }
                    else {
                        this.$refs.userBinFenCustomerForm.resetFields();
                    }
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onSave() {
            this.$refs.userBinFenCustomerForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userBinFenCustomerForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                binFenCustomerUserSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getBinFenCustomerUserTableRecords();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
